import { Typography } from "@material-ui/core"
import React, { FunctionComponent } from "react"

interface StorageProgressLabelProps {
    maxStorage: number
    currentStorage: number
}

export const StorageProgressLabel: FunctionComponent<StorageProgressLabelProps> = ({
    maxStorage,
    currentStorage
}) => {
    return (
        <Typography
            data-testid="storage-progress-label"
            id="storage-progress-label"
            variant="body1"
        >
            {`${currentStorage.toFixed(2)} GB / ${maxStorage.toFixed(2)} GB`}
        </Typography>
    )
}
